import {
  RESEND_RESETPW_CODE_REQUESTING,
  } from './constants'
  
export const resendResetPwCodeRequest = function resendResetPwCodeRequest (formData) {
  return {
    type: RESEND_RESETPW_CODE_REQUESTING,
    formData,
  }
}
  
export default resendResetPwCodeRequest


// WEBPACK FOOTER //
// ./src/views/Pages/ResendResetPwCode/actions.js